<div class="main-header">
  <div class="logo-header">

<a href="/home" class="logo">
      <img [src]="logoImageBase64" alt="Company Logo" class="navbar-brand img-fluid"/>
    </a>
    <button class="navbar-toggler sidenav-toggler ml-auto" type="button" (click)="toggleSidebar()">
      <span class="navbar-toggler-icon">
        <i class="icon-menu"></i>
      </span>
    </button>
    <button class="topbar-toggler more" (click)="toggleTopbar()">
       <img src="../../../assets/images/mc.png" alt="MC" class="img-fluid menu-icon topbar-icon" style="width:30px;height:30px;" (click)="toggleTopbar()"/>
      <i class="icon-options-vertical" style="color:red;" (click)="toggleTopbar()"></i>
    </button>
    <div class="nav-toggle">
      <button class="btn btn-toggle toggle-sidebar" (click)="toggleSidebar()">
        <i class="icon-menu" title="Burger" style="color: red;"></i>
      </button>
    </div>
  </div>

  <nav class="navbar navbar-header navbar-expand-lg hide-on-mobile" data-background-color="blue2">

    <div class="navbar-nav- topbar-nav- mr-auto">
      <div class="row">
        <!-- <div class="col-md-6">
          <ng-select class="form-control-- form-control-sm-- locations" [items]="locations" [markFirst]="true"
            bindLabel="Code" bindValue="Code" [(ngModel)]="selectedLocation" placeholder="Select Location">
          </ng-select>
        </div> -->
        <div class="col-md-4">
          <button class="btn btn-primary btn-md" data-toggle="modal" data-target="#actionsItemsForm"
            (click)="getActionItems()">Pending Actions</button>
        </div>
        <div class="col-md-2">
          <button class="btn btn-primary btn-md" data-toggle="modal" data-target="#pendingInwards"
            (click)="getPendingInwards()"> Pending Inwds: {{pendingInwardsCount}}</button>
        </div>
      </div>
    </div>

    <ul class="navbar-nav topbar-nav ml-auto">
      <li class="nav-item dropdown hidden-caret">
        <form class="form-inline mr-3 mt-1 search-topnav">
          <button class="btn btn-sm btn-primary my-2 my-sm-0" type="submit">Search</button>
          <button class="btn btn-primary btn-sm mr-2" data-toggle="modal" data-target="#passwordChangeForm"
            (click)="openChangePasswordForm()">Change Password</button>
        </form>
      </li>
      <li class="nav-item dropdown hidden-caret">
        <a class="dropdown-toggle profile-pic" data-toggle="dropdown" href="#" aria-expanded="false">
          <div class="float-left text-right">
            <div class="f-12px mb-0 mr-2 mt-1 pb-0 text-light">
              {{(user) ? user.FirstName : ''}} - {{(user) ? user.AccessLevel : ''}}
            </div>
            <div class="f-11px mb-0 mr-2 pt-0 text-light">{{(user) ? user.LocationType : ''}} :
              {{(user) ? user.BranchName : ''}}</div>
            <div class="f-11px mb-0 mr-2 pt-0 text-light">FinancialYear : {{(user) ? user.FinancialYear : ''}}</div>
          </div>
          <div class="avatar-sm float-left">
            <img src="assets/img/profile.jpg" alt="..." class="avatar-img rounded-circle">
          </div>
        </a>
        <ul class="dropdown-menu dropdown-user animated fadeIn">
          <div class="dropdown-user-scroll scrollbar-outer">
            <li>
              <div class="user-box">
                <div class="avatar-lg"><img src="assets/img/profile.jpg" alt="image profile" class="avatar-img rounded">
                </div>
                <div class="u-text">
                  <h4>{{(user)?user.FirstName:''}}</h4>
                  <h4>{{(user)?user.EmployeeCode:''}}</h4>
                  <p class="text-muted">{{(user)?user.EmailID:''}}</p>
                  <a href="#" class="btn btn-xs btn-outline-secondary btn-sm" data-toggle="modal"
                    data-target="#profileModal">
                    View Profile
                  </a>
                  <a href="" class="btn btn-xs btn-outline-secondary btn-sm ml-1" (click)="logout()">Logout</a>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </li>
    </ul>
  </nav>
</div>

<div class="modal fade" id="actionsItemsForm">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Pending Actions Form</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <form [formGroup]="pendingActionsForm" class="form-horizontal" novalidate>
        <div class="modal-body">
          <div class="form-row">
            <div class="col-md-12">
              <div class="form-field">
                <div class="col-md-20">
                  <textarea class="form-control" formControlName="ActionDescription" required></textarea>
                  <label class="f-12 font-weight-bold">Description</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-col4">
              <div class="form-field">
                <ng-select [items]="actionTypeList" placeholder="Select Action Type" formControlName="ActionType"
                  required>
                </ng-select>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <ng-select [items]="moduleList" placeholder="Select Module" formControlName="ModuleName" required>
                </ng-select>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <ng-select [items]="priorityList" placeholder="Select Priority" formControlName="Priority" required>
                </ng-select>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <input type="date" class="form-control" formControlName="CreatedDate" name="CreatedDate" readonly>
                <label class="f-12 font-weight-bold">Created Dt</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-col4">
              <div class="form-field">
                <input type="date" class="form-control" formControlName="UpdatedDate" name="UpdatedDate" readonly>
                <label class="f-12 font-weight-bold">Updated Dt</label>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <input type="date" class="form-control" formControlName="Eta" name="Eta" required [min]="todayDate">
                <label class="f-12 font-weight-bold">ETA</label>
                <div *ngIf="pendingActionsForm.get('Eta')?.invalid && (pendingActionsForm.get('Eta')?.dirty || pendingActionsForm.get('Eta')?.touched)" class="text-danger mt-1">
                  <small *ngIf="pendingActionsForm.get('Eta')?.errors?.['required']">ETA is required</small>
                  <small *ngIf="pendingActionsForm.get('Eta')?.errors?.['invalidDate']">Past dates are not allowed. Please select today or a future date.</small>
                </div>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <input type="text" class="form-control" formControlName="Comment" required>
                <label class="f-12 font-weight-bold">Comment</label>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <input type="text" class="form-control" formControlName="RequestedBy" required>
                <label class="f-12 font-weight-bold">Requested By</label>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-col4">
              <div class="form-field">
                <input type="number" class="form-control" formControlName="HoursWorked" required min="1">
                <label class="f-12 font-weight-bold">No.Hours</label>
                <div *ngIf="pendingActionsForm.get('HoursWorked')?.invalid && (pendingActionsForm.get('HoursWorked')?.dirty || pendingActionsForm.get('HoursWorked')?.touched)" class="text-danger mt-1">
                  <small *ngIf="pendingActionsForm.get('HoursWorked')?.errors?.['required']">Hours worked is required</small>
                  <small *ngIf="pendingActionsForm.get('HoursWorked')?.errors?.['min']">Hours must be at least 1. Zero hours not allowed.</small>
                </div>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <input type="text" class="form-control" formControlName="AssignedTo" required>
                <label class="f-12 font-weight-bold">Assigned To</label>
              </div>
            </div>
            <div class="form-col4">
              <div class="form-field">
                <ng-select [items]="statusList" placeholder="Select Status" formControlName="Status" required>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer d-flex justify-content-between align-items-center">
        <div>
          <button class="btn btn-success btn-sm mr-1" (click)="saveActionItems()">Save</button>
          <button class="btn btn-primary btn-sm mr-1" (click)="setActionItemDefaultValues()">Cancel</button>
          <button class="btn btn-danger btn-sm" data-dismiss="modal">Close</button>
        </div>
        <div>
          <button type="button" class="btn btn-sm btn-primary" (click)="exportExel()" [disabled]="disableExportBtn">
            <i class="far fa-file-excel mr-2"></i>
            Export to Excel
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="d-flex flex-row">
            <ag-grid-angular style="height: 300px;" class="ag-theme-balham w-100" [gridOptions]="gridOptions"
              [columnDefs]="columnDefs" [showToolPanel]="showToolPanel" (rowClicked)="onRowClicked($event)"
              [rowData]='pendingActionsList'>
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="pendingInwards">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Pending Inwards</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="d-flex flex-row-reverse">
            <button type="button" class="btn btn-sm btn-primary mt-2 mb-1" (click)="exportPendingInwardsExel()"
              [disabled]="disableInwrdExportBtn">
              <i class="far fa-file-excel mr-2"></i>
              Export to Excel
            </button>
          </div>
          <div class="d-flex flex-row">
            <ag-grid-angular style="height: 300px;" class="ag-theme-balham w-100" [gridOptions]="gridOptions"
              [columnDefs]="columnDefsPenInwrds" [showToolPanel]="showToolPanel" [rowData]='pendingInwardsList'>
            </ag-grid-angular>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="passwordChangeForm">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Change Password Form</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="clearPasswordFrom()">&times;</button>
      </div>
      <!-- Replace the existing password form section with this -->
      <form [formGroup]="changePasswordForm">
        <div class="modal-body">
          <div *ngIf="showChangePasswordForm">
            <div class="form-row mb-3">
              <div class="col-12">
                <div class="form-field w-100">
                  <input type="password" class="form-control" formControlName="CurrentPassword" name="CurrentPassword"
                    required>
                  <label class="f-12 font-weight-bold">Current Password</label>
                </div>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col-12">
                <div class="form-field w-100">
                  <input type="password" class="form-control" formControlName="NewPassword" required>
                  <label class="f-12 font-weight-bold">New Password <span>[Min len (8) and Max len.(12)]</span></label>
                </div>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col-12">
                <div class="form-field w-100">
                  <input type="password" class="form-control" formControlName="ConfirmPassword" required>
                  <label class="f-12 font-weight-bold">Confirm Password</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!--Customer Modal footer- Close button -->
      <div *ngIf="showChangePasswordForm" class="modal-footer">
        <button class="btn btn-success btn-sm mr-1" (click)="savePassword()">Save</button>
        <button class="btn btn-primary btn-sm mr-1" (click)="clearPasswordFrom()">Reset</button>
        <button class="btn btn-danger btn-sm" data-dismiss="modal" (click)="clearPasswordFrom()">Close</button>
      </div>

      <div *ngIf="showChangePasswordMsg" class="row">
        <div class="col-md-7">
          <div class="row mb-3">
            <div class="col-md-10">
              <div class="alert alert-success">
                <strong>Success.!</strong> Password changed successfully..!!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showChangePasswordMsg" class="row">
        <div class="col-md-7">
          <div class="row mb-3">
            <div class="col-md-10">
              <span>
                <label class="f-12 font-weight-bold">Please logout and login with new password</label>
                <a href="" class="btn btn-xs btn-outline-secondary btn-sm ml-1 pull-right" (click)="logout()">Logout</a>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Profile Modal -->
<div class="modal fade" id="profileModal" tabindex="-1" role="dialog" aria-labelledby="profileModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="profileModalLabel">User Profile</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="text-center mb-3">
          <img src="assets/img/profile.jpg" alt="Profile" class="avatar-img rounded-circle"
            style="width: 80px; height: 80px;">
        </div>
        <table class="table table-borderless">
          <tr>
            <th>Name:</th>
            <td>{{ user?.FirstName }}</td>
          </tr>
          <tr>
            <th>Role:</th>
            <td>{{ user?.AccessLevel }}</td>
          </tr>
          <tr>
            <th>Employee Code:</th>
            <td>{{ user?.EmployeeCode }}</td>
          </tr>
          <tr>
            <th>Email:</th>
            <td>{{ user?.EmailID }}</td>
          </tr>
          <tr>
            <th>Branch:</th>
            <td>{{ user?.BranchName }}</td>
          </tr>
          <!-- Add more fields as needed -->
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
